const initFullScreenSlider = () => {
	const sections = document.querySelectorAll("section.slideshow-fullscreen");

	if (!sections.length) {
		return;
	}
	Array.from(sections).forEach((section) => {
		const slider = section.querySelector(".swiper");
		const slides = slider.querySelectorAll(".swiper-slide");

		new Swiper(slider, {
			slidesPerView: 1,
			autoHeight: true,
			loop: true,
			navigation: {
				nextEl: ".button-next",
				prevEl: ".button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
                clickable: true,
			},
		});
	});
};

export { initFullScreenSlider };
